import React from 'react';
import { useParams } from 'react-router-dom';
import { useIsDesktop, useTranslations } from 'components/utilities';
import useVerification from './useVerification';
import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import { Form } from 'react-final-form';
import { INITIAL_VALUES, validate } from './helpers';
import { TextField } from 'mui-rff';

function Verification() {
	const { t } = useTranslations();
	let { id, token: initToken, isSupportingSms, isSupportingCall } = useParams();

	const {
		resendSuccess,
		recallSuccess,
		timeLeft,
		handleOnSubmit,
		handleResendCode,
		handleResendCall,
	} = useVerification({ id, initToken });

	const isDesktop = useIsDesktop();

	const boxPaddings = {
		py: isDesktop ? 6 : 3,
		px: isDesktop ? 12 : 3,
	};

	return (
		<Box p={isDesktop ? 3 : 0}>
			<Paper square>
				<Box
					{...boxPaddings}
					style={isDesktop ? null : { textAlign: 'center' }}
				>
					<Form
						onSubmit={handleOnSubmit}
						validate={validate(t)}
						initialValues={INITIAL_VALUES}
					>
						{({ handleSubmit, submitting }) => (
							<form onSubmit={handleSubmit} autoComplete="off">
								<Typography variant={isDesktop ? 'h1' : 'h5'}>
									{t('verification.header')}
								</Typography>

								{process.env.NODE_ENV !== 'production' && (
									<Typography>
										id: {id}
										<br />
										token: {initToken}
									</Typography>
								)}

								<Box mt={isDesktop ? 5 : 2}>
									<TextField
										autoComplete="new-password"
										variant="outlined"
										label={t('verification.codeLabel')}
										name="code"
										fullWidth
										margin="normal"
										disabled={submitting}
									/>
								</Box>
								<Box mt={isDesktop ? 5 : 3}>
									{resendSuccess && (
										<Box mb={3}>
											<Typography variant="h5">
												{t('verification.sendSuccess')}
											</Typography>
										</Box>
									)}
									{recallSuccess && (
										<Box mb={3}>
											<Typography variant="h5">
												{t('verification.callSuccess')}
											</Typography>
										</Box>
									)}
									{timeLeft > 0 && timeLeft < 10 && (
										<Typography variant="h5">
											{t('verification.pleaseWait')} {timeLeft}
										</Typography>
									)}
									{timeLeft <= 0 && (
										<>
											<Grid container spacing={3}>
												{isSupportingSms !== 'false' && (
													<Grid item xs={6} md={3}>
														<Button
															variant="contained"
															color="secondary"
															size="small"
															fullWidth
															onClick={handleResendCode}
														>
															{t('verification.sendAgain')}
														</Button>
													</Grid>
												)}
												{isSupportingCall !== 'false' && (
													<Grid item xs={6} md={3}>
														<Button
															variant="contained"
															color="secondary"
															size="small"
															fullWidth
															onClick={handleResendCall}
														>
															{t('verification.receiveCall')}
														</Button>
													</Grid>
												)}
											</Grid>
										</>
									)}
								</Box>

								<Box pt={6}>
									<Button
										type="submit"
										variant="contained"
										color="primary"
										fullWidth
										size={isDesktop ? 'large' : 'medium'}
										disabled={submitting}
									>
										{t('verification.button')}
									</Button>
								</Box>
							</form>
						)}
					</Form>
				</Box>
			</Paper>
		</Box>
	);
}

export default Verification;
